(() => {
  const stlMobileSwiper = new Swiper(".js-stl-mobile-card-swiper", {
    loop: false,
    slidesPerView: 1,
    pagination: {
      el: ".js-stl-mobile-card-pagination",
    },
    /* navigation: {
      nextEl: ".js-stl-mobile-card-next",
    }, */
  });

  const radioButtons = document.querySelectorAll(".js-stl__radio-button");

  Array.from(radioButtons).forEach(function (btn, i) {
    btn.addEventListener("change", () => {
      stlMobileSwiper.slideTo(i, 200, false);
    });
  });

  // Update radio buttons when slides change (including manual drag/swipe)
  stlMobileSwiper.on("slideChange", function () {
    const activeIndex = stlMobileSwiper.realIndex;
    if (radioButtons[activeIndex]) {
      radioButtons[activeIndex].checked = true;
    }
  });

  // Also handle snapIndexChange for programmatic changes
  stlMobileSwiper.on("snapIndexChange", function () {
    const activeIndex = stlMobileSwiper.realIndex;
    if (radioButtons[activeIndex]) {
      radioButtons[activeIndex].checked = true;
    }
  });
})();
